import { useContext, useEffect } from "react";
import ConfigureTarget from "../configure-target/configure-target";
import ValidateTarget from "../validate-target/validate-target";
import ReviewWrapper from "../summary/summary";
import { Steps, getStepID } from "../../target-steps";
import { WizardContext } from "../../../wizard-context";
import navigateTo from "../../../../../navigate-to";
import { getWizardType } from "../../../utils/checkAdapterType";
import { isAutomatedWizard } from "../../../../../../app/components/appwizard/component-wizards/wizards/source/database-reader/app-services";
import TableMappingEditor from "../table-mapping-editor/table-mapping-editor";
import metaStoreService from "core/services/metaStoreService/meta-store-service";

interface TargetLayoutProps {
    target: string;
    appName: string;
    templateID: string;
    stepName: string;
    prefillWizardData: any;
}

const TargetLayout = ({ target, appName, templateID, stepName, prefillWizardData }: TargetLayoutProps) => {
    const {
        currentStep,
        setWizardAppName,
        setCurrentStep,
        setTemplateID,
        setIsAutomatedILCDC,
        setWizardType,
        setSourceInfo,
        setCdcSourceInfo,
        setTargetInfo,
        setCdcTargetInfo
    } = useContext(WizardContext);

    const navigateParams = {
        appName,
        templateId: templateID,
        stepId: 1,
        force: false
    };

    useEffect(() => {
        const isILCDCApp = isAutomatedWizard();
        setTemplateID(templateID);
        setCurrentStep(getStepID(stepName));
        setWizardAppName(appName);
        setIsAutomatedILCDC(isILCDCApp);
    }, []);

    useEffect(() => {
        if (!prefillWizardData) return;
        const wizardData = prefillWizardData[metaStoreService.entities.TARGET];
        if (wizardData) {
            const { targetInfo, cdcTargetInfo, sourceInfo, cdcSourceInfo } = wizardData;
            setTargetInfo(targetInfo);
            setCdcTargetInfo(cdcTargetInfo);
            setSourceInfo(sourceInfo);
            setCdcSourceInfo(cdcSourceInfo);
            setWizardType(getWizardType(sourceInfo?.adapterName));
        }
    }, []);

    switch (currentStep) {
        case Steps.ConfigureTarget:
            navigateTo.AppWizardTemplate({
                ...navigateParams,
                stepName: "configure-target"
            });
            return <ConfigureTarget target={target} />;
        case Steps.TableMappingEditor:
            navigateTo.AppWizardTemplate({
                ...navigateParams,
                stepName: "table-mapping-editor"
            });
            return <TableMappingEditor target={target} />;
        case Steps.ValidateTarget:
            navigateTo.AppWizardTemplate({
                ...navigateParams,
                stepName: "validate-target"
            });
            return <ValidateTarget target={target} />;
        case Steps.Review:
            navigateTo.AppWizardTemplate({
                ...navigateParams,
                stepName: "review"
            });
            return <ReviewWrapper target={target} />;
    }
};

export default TargetLayout;
